<div class="d-flex">
  <div class="flex-1"></div>
  <div class="flex-1 flex-no-shrink search-container">
    <app-form-field-text
      (keyup.enter)="reload()"
      [field]="searchControl"
     
      label="label.search"
    ></app-form-field-text>
  </div>
  <div class="d-flex">
    <button (click)="reload()" type="button" class="btn border-0">
      <i class="bi bi-search"></i>
    </button>
    <button [routerLink]="['create']" color="primary" class="btn btn-primary rounded-circle d-flex align-items-center justify-content-center">
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>
</div>
